import type { PositionsList } from '@/queries/positions.query'

export const MIN_POSITION_USD_THRESHOLD = 0.05

export const getPositionsAboveThreshold = (positions: PositionsList) => {
  return positions?.filter((position) => {
    return Number(position.balanceUsd) >= MIN_POSITION_USD_THRESHOLD
  })
}
